import axios from "axios";

export const CPT_API = "cpt";

export const getAllCpts = () => {
  return axios.get(`${CPT_API}`);
}

// Legacy: /cpt?search=... — se mantiene por compatibilidad
export const searchCpts = (query) => {
  return axios.get(`${CPT_API}?search=${query}`);
}

// Nuevo: /cpt/search?q=... incluye specialty y REMOVE_ACCENTS
export const searchCptsWithSpecialty = (query) => {
  return axios.get(`${CPT_API}/search`, { params: { q: query } });
}

export const getCptSpecialties = () => {
  return axios.get(`${CPT_API}/specialties`);
}
